import { attemptMethod } from "./general"
import { ProductConfiguration } from "./productConfiguration/productConfiguration.types"

export const getProductConfigurationPreview = (configuration?: Record<string, unknown>, productConfiguration?: ProductConfiguration) => {
    return attemptMethod(() => {
        if (configuration![productConfiguration!.previewPath!]) {
            return `(${configuration![productConfiguration!.previewPath!]})`;
        }

        return '';
    }, '')
}